import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AnalyticsTracker } from "@/components/AnalyticsTracker";
import Landing from "@/pages/Landing";
import GalleryPage from "@/pages/GalleryPage";
import RequestPage from "@/pages/RequestPage";
import LoginPage from "@/pages/LoginPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import AdminDashboard from "@/pages/AdminDashboard";
import ContactsPage from "@/pages/ContactsPage";
import QuotePage from "@/pages/QuotePage";
import StatusPage from "@/pages/StatusPage";
import FeedbackPage from "@/pages/FeedbackPage";
import StatsPage from "@/pages/StatsPage";
import PromotionsPage from "@/pages/PromotionsPage";
import CreatePosterPage from "@/pages/CreatePosterPage";
import VideoAdPage from "@/pages/VideoAdPage";
import FinancePage from "@/pages/FinancePage";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AnalyticsTracker />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/galleria" element={<GalleryPage />} />
            <Route path="/preventivo" element={<QuotePage />} />
            <Route path="/stato" element={<StatusPage />} />
            <Route path="/recensioni" element={<FeedbackPage />} />
            <Route path="/contatti" element={<ContactsPage />} />
            <Route path="/richiesta" element={<RequestPage />} />
            <Route path="/promozioni" element={<PromotionsPage />} />
            <Route path="/admin/locandina" element={<ProtectedRoute><CreatePosterPage /></ProtectedRoute>} />
            <Route path="/admin/video" element={<ProtectedRoute><VideoAdPage /></ProtectedRoute>} />
            <Route path="/admin/finanze" element={<ProtectedRoute><FinancePage /></ProtectedRoute>} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/statistiche" element={<ProtectedRoute><StatsPage /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
